import AppContent from '@components/App/appContent';
import PageContentWrapper from '@components/App/PageComponents/pageContentWrapper';
import { withStyles } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import AdminSettingsDrawer from '../../../components/App/Drawers/adminSettingsDrawer';


const styles = theme => ({
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
        align: 'center'
    },
    spinner: {
        textAlign: 'center',
        paddingTop: 16
    },
    paper: {
        padding: 16
    },
    paperStyle: {
        marginBottom: 40
    },
    listStyle: {
        paddingTop: 0,
        paddingBottom: 0
    },
    button: {
        margin: 16
    }
})

class Graph extends React.Component {
    constructor(props, context) {
        super(props, context);


    }

    render() {
        return <AppContent >
            <PageContentWrapper isFull={true} drawer={<AdminSettingsDrawer selected="knowledge_graph" />}>
                {this.props.token ? <iframe style={{border:'none'}} src={"/graph/index.html?token=" + this.props.token} width="100%" height="1500px" /> : <div data-intrcm-id="graph_4agwco94" />}

            </PageContentWrapper>
        </AppContent>;
    }
}
const mapStateToProps = (state) => ({
    ...state.services,
    templates: state.globalData.templates,
    token: state.userData.idToken,

})


const mapDispatchToProps = dispatch => {
    return {        
        dispatch: dispatch
    }
}

export default compose(withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(Graph);